import { useQuery } from '@tanstack/react-query';
import { ApiError } from 'src/types/interfaces/api-error';

import { hostsApi } from '../../api/lib/hosts';
import { hostsKeys } from '../../api/query-keys/hosts';
import { Host } from '../../api/types/host';

export const useHost = (hostId: number) => {
  return useQuery<Host, ApiError>({
    queryKey: hostsKeys.detail(hostId),
    queryFn: () => hostsApi.fetchHost(hostId),
  });
};
